import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FormVAQ_UB_3 from "../../Forms/FormVAQ_UB_3.js";
import Header from "../../Includes/Layouts/VAQ_UB_3/Header.js";
import Footer from "../../Includes/Layouts/VAQ_UB_3/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel";
import "../../../assets/VAQ_UB_3/css/VAQ_UB_3.scss";
import Section1 from "../../Includes/Layouts/VAQ_UB_3/Section1.js";
import AccordSection from "../../Includes/Layouts/VAQ_UB_3/AccordSection";

const VAQ_UB_3 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="VAQ_UB_3" />
      <FbViewPixel />
      <div className="VAQ_UB_3">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormVAQ_UB_3 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default VAQ_UB_3;